import React, { FC } from 'react'
import { useRouter } from 'next/router'
import { GetStaticPropsResult, GetStaticPathsResult } from 'next'
import Proyectos, { projects } from '../components/projects'
type Empty = {
}
const Home : FC = () => {
  const router = useRouter()
  const { pid } = router.query
  return (<Proyectos pid={String(pid)} />)
}
export async function getStaticProps (): Promise<GetStaticPropsResult<Empty>> {
  return {
    props: {
    }
  }
}

export async function getStaticPaths (): Promise<GetStaticPathsResult> {
  return {
    paths: projects.map(p => ({ params: { pid: p.key } })),
    fallback: false
  }
}
export default Home
